<form [formGroup]="form">

  <div class="form-row mb-5">
    <div class="form-group col-md-3">

      <label>Senha Atual</label>
      <input class="form-control" type="password" placeholder="" formControlName="senhaAtual">


      @if (this.form.get('senhaAtual')?.invalid && (this.form.get('senhaAtual')?.touched || this.form.get('senhaAtual')?.dirty)) {
        <div>
          <small class="text-danger">
            Campo Obrigatório
          </small>
        </div>
      }
    </div>
  </div>

  <div class="form-row">
    <div class="form-group col-md-3">

      <label>* Nova Senha</label>
      <input class="form-control" type="password" placeholder="" formControlName="novaSenha">

      @if (this.form.get('novaSenha')?.invalid && this.form.get('novaSenhaConf')?.invalid && this.form.get('novaSenha')?.touched) {
        <div>
          <small class="text-danger">
            A senha deve conter no mínimo 8 caracteres, letras maiúsculas e minusculas e pelo menos um caractere especial
          </small>
        </div>
      }
    </div>
  </div>

  <div class="form-row">
    <div class="form-group col-md-3">

      <label>Confirme a Nova Senha</label>
      <input class="form-control" type="password" placeholder="" formControlName="novaSenhaConf">

      @if (this.form.get('novaSenha')?.value !== this.form.get('novaSenhaConf')?.value && this.form.get('novaSenhaConf')?.touched) {
        <div>
          <small class="text-danger">
            As senhas devem ser iguais
          </small>
        </div>
      }

    </div>
  </div>

  <p class="mb-3 pr-5">
  </p>

  @if (msgErro!=null) {
    <div class="msgErroForm">
      {{msgErro}}
    </div>
  }

  <button class="btn btn-success mx-2" target="_blank" (click)="salvarAltSenha()" [disabled]="!form.valid || loading">
    Alterar Senha
    @if (loading) {
      <i class="fas fa-spinner fa-spin"></i>
    }
  </button>

</form>
